export const DeviceStatusBadge = {
  flow: 'x',
  align: 'center center',
  gap: 'X',
  display: 'inline-flex',

  StatusDot: {
    width: '8px',
    height: '8px',
    round: 'D',
    flexShrink: '0',
    background: (el, s) => {
      const st = s.deviceStatus || 'disconnected'
      if (st === 'connected') return 'teal'
      if (st === 'scanning') return 'amber'
      return 'inkMuted'
    },
    animation: (el, s) => s.deviceStatus === 'scanning' ? 'pulse 1.5s ease-in-out infinite' : 'none'
  },

  StatusText: {
    text: (el, s) => {
      const st = s.deviceStatus || 'disconnected'
      if (st === 'connected') return '{{ connected | polyglot }}'
      if (st === 'scanning') return '{{ scanning | polyglot }}'
      return '{{ disconnected | polyglot }}'
    },
    fontSize: 'Y',
    fontWeight: '500',
    color: (el, s) => {
      const st = s.deviceStatus || 'disconnected'
      if (st === 'connected') return 'teal'
      if (st === 'scanning') return 'amber'
      return 'inkMuted'
    }
  }
}
